import dayjs, {Dayjs} from 'dayjs';
import {DatePickerType, DatePickerValidation} from '../../../constants/tasks';

export const calculateMinDate = (
    type?: DatePickerType, validationType?: DatePickerValidation
): Nullable<Dayjs> => {
  const onlyFutureDatesAllowed =
    validationType === DatePickerValidation.FUTURE_DATE;
  const futureAndCurrentDatesAllowed =
    validationType === DatePickerValidation.FUTURE_OR_CURRENT_DATE;

  if (futureAndCurrentDatesAllowed ||
    onlyFutureDatesAllowed && type === DatePickerType.DATE_TIME) {
    return dayjs();
  };

  if (onlyFutureDatesAllowed && type === DatePickerType.DATE) {
    return dayjs().add(1, 'day');
  }

  return null;
};
